module.exports = {
  ...require('./warmup-data'),
  ...require('./duration'),
};
